import Joi from "joi-browser";

import { ConditionalRuleMode } from "../Models/Conditional";
import { AssistantNodeAction, NodeType } from "../Models/NodeType";
import {
  getVoiceCallActionConfigureData,
  voiceCallActionFormSchema,
} from "./Assistant/VoiceCallAction/useVoiceCallActionForm";
import {
  conditionRuleFormSchema,
  getConditionRuleConfigureData,
} from "./Conditional/ConditionRules/useConditionRuleForm";
import {
  externalApiFormSchema,
  getExternalApiConfigureData,
} from "./ExternalApi/useExternalApiForm";
import {
  getWebhookTriggerConfigureData,
  webhookTriggerConfigSchema,
} from "./WebhookTrigger/useWebhookTriggerConfigForm";
import {
  getWaitForCallbackConfigureData,
  waitForCallbackConfigSchema,
} from "./WaitForCallback/useWaitForCallbackForm";
import {
  delayNodeConfigSchema,
  getDelayNodeConfigureData,
} from "./Delay/useDelayForm";
import {
  whatsappMessageActionFormSchema,
  getWhatsappMessageActionConfigureData,
} from "./Assistant/WhatsappMessageAction/useWhatsappMessageActionForm";

export const nodeValidationSchema = {
  [NodeType.WEBHOOK_TRIGGER]: {
    default: {
      schema: webhookTriggerConfigSchema,
      getConfigureData: getWebhookTriggerConfigureData,
    },
  },
  [NodeType.EXTERNAL_API]: {
    default: {
      schema: externalApiFormSchema,
      getConfigureData: getExternalApiConfigureData,
    },
  },
  [NodeType.ASSISTANT]: {
    [AssistantNodeAction.VOICE_CALL]: {
      schema: voiceCallActionFormSchema,
      getConfigureData: getVoiceCallActionConfigureData,
    },
    [AssistantNodeAction.WHATSAPP_MESSAGE]: {
      schema: whatsappMessageActionFormSchema,
      getConfigureData: getWhatsappMessageActionConfigureData,
    },
  },
  [NodeType.CONDITIONAL]: {
    [ConditionalRuleMode.RULES]: {
      schema: conditionRuleFormSchema,
      getConfigureData: getConditionRuleConfigureData,
    },
  },
  [NodeType.WAIT_FOR_CALLBACK]: {
    default: {
      schema: waitForCallbackConfigSchema,
      getConfigureData: getWaitForCallbackConfigureData,
    },
  },
  [NodeType.DELAY]: {
    default: {
      schema: delayNodeConfigSchema,
      getConfigureData: getDelayNodeConfigureData,
    },
  },
} as const;

export const validateNodeConfig = (nodeType, subType, nodeData) => {
  const schema = nodeValidationSchema[nodeType]?.[subType]?.schema;
  if (!schema) return { isValid: true, errors: {} };

  const getConfigureData =
    nodeValidationSchema[nodeType]?.[subType]?.getConfigureData;
  const validateData = getConfigureData ? getConfigureData(nodeData) : nodeData;

  const { error } = Joi.object(schema).validate(validateData, {
    abortEarly: false,
    allowUnknown: true,
  });

  if (!error) return { isValid: true, errors: {} };

  const errors = error.details.reduce((acc, detail) => {
    acc[detail.path[0]] = detail.message;
    return acc;
  }, {});

  return { isValid: false, errors };
};
